<template>
  <iframe ref="iframeRef" :src="src" frameborder="0"></iframe>
</template>

<script>

export default {
  name: 'app-viewer-iframe',
  props: {
    src: {
      type: String,
      default: '',
    },
    studentId: {
      type: String,
      default: '',
    },
  },
  mounted() {
    const iframe = this.$refs.iframeRef
    iframe.addEventListener('load', () => {
      iframe.contentWindow.postMessage({
        command: 'postStudentId',
        data: {
          studentId: this.studentId,
        },
      }, '*')
    })
  },
}
</script>